<script>
  import { onMount } from "svelte";
  import { makeWebsiteRequest } from "../Common/tools";
  import Table from "../Table/Table.svelte";
  import {External, M} from "../external";

  let selection = null;
  let loading = false;
  let count = 0;
  let currentPage = 1;
  let pagesCount = 0;

  let data = {
    count: 0,
    columns: [
      {
        key: "id",
        label: 'ID',
        class: "flex-1 mw-140 ws-normal"
      },
      {
        key: "time",
        label: "Created On",
        class: "flex-1 mw-140 ws-normal"
      },
      {
        key: "name",
        label: M.NAME,
        class: "flex-1 mw-140 ws-normal"
      },
      {
        key: "email",
        label: M.EMAIL,
        class: "flex-1 mw-140 ws-normal"
      },
      {
        key: "amount",
        label: "Amount",
        class: "flex-1 mw-140 ws-normal"
      }
    ],
    rows: []
  };

  async function listTransactions(page, append) {
    if (loading) return;

    loading = true;

    let request = {
      skip: 0,
      page: page,
      type: "barclays"
    };

    let response = await makeWebsiteRequest({
      action: "listStoreTransactions",
      data: request
    });

    if (!response.data) {
      loading = false;
      return;
    }

    data.count = response.data.count;
    count = response.data.count;
    pagesCount = response.data.pagesCount;
    currentPage = page;

    let items = response.data.items;
    loading = false;
    items.forEach((item) => {
      item.email = item.email || "";
      item.name = item.firstName || "";
      if (item.lastName) item.name += " " + item.lastName;
      item.time = External.Tools.dateToString(new Date(item.time), true, true, false);
      item.amount = External.WebPlatform.currencyWithCodeToStr(item.amount || 0, item.amount ? item.currency : "");
    });
    if (append) {
      data.rows = data.rows.concat(items);
    } else {
      data = Object.assign({}, data, { rows: items });
    }
  }

  let onNext = (scrollableBody) => {
    if (loading || true) return;
    if (count === null || currentPage + 1 >= pagesCount) return;
    listTransactions(currentPage + 1, true);
  };

  onMount(function () {
    listTransactions(0);
  });
</script>

<div class="account-settings store-products flex-1 horizontal-flex-table col20" style="font-family: 'Roboto';">
  <div class="content-wrapper horizontal-flex-table" style="max-width:1200px; width: 94%;">
    <div class="sections-wrapper members-wrapper horizontal-flex-table">
      <div class="section-bg members-wrapper crm-table-outer mt-15">
        <Table activeColumns={data.columns} bind:data={data.rows} bind:selection loading={loading} hideHeadOnLoad={true} hasSelection={false} nextPage={onNext}>
          <div class="text-center col20 f-left" style="padding: 50px 30px 70px 30px; box-sizing: border-box;">
            <h4 class="col20 f-left t-center mb-15">No Transactions Yet</h4>
          </div>
        </Table>
      </div>
    </div>
  </div>
</div>
